enum StepNames {
	START = 'Start',
	SHAPE = 'Shape',
	PAINT = 'Paint',
	ANIMATE = 'Animate',
	RESULTS = 'Results',
}

export default StepNames;
